import { render, staticRenderFns } from "./phonetics-sheet.vue?vue&type=template&id=4f2e128a&scoped=true&"
import script from "./phonetics-sheet.vue?vue&type=script&lang=js&"
export * from "./phonetics-sheet.vue?vue&type=script&lang=js&"
import style0 from "./phonetics-sheet.vue?vue&type=style&index=0&id=4f2e128a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2e128a",
  null
  
)

export default component.exports